import React from "react";
import SlickSlider from "react-slick";

import defaultStyles from "./main.module.scss";

export const Arrow = ({ onClick, isPrev, styles = defaultStyles, className }) => (
  <div
    role="button"
    onClick={onClick}
    onKeyPress={onClick}
    tabIndex={isPrev ? 0 : 1}
    className={`${className} ${styles[isPrev ? "prev" : "next"]}`}
  />
);

export const Slider = ({ styles = defaultStyles, children, ...restConfigs }) => {
  const nextArrow = <Arrow styles={styles} />;
  const prevArrow = <Arrow styles={styles} isPrev />;
  const renderAppendDots = (dots) => <ul>{dots}</ul>;
  return (
    <SlickSlider
      className={styles.slickContainer}
      nextArrow={nextArrow}
      prevArrow={prevArrow}
      appendDots={renderAppendDots}
      dotsClass={styles.dots}
      {...restConfigs}
    >
      {children}
    </SlickSlider>
  );
};
